import script from "./ToolbarIconButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolbarIconButton.vue?vue&type=script&setup=true&lang=ts"

import "./ToolbarIconButton.vue?vue&type=style&index=0&id=754bee50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-754bee50"]])

export default __exports__